<script setup lang="ts">
/* eslint-disable vue/no-v-html */
interface PagebuilderFaqProps {
    data: {
        faq: FAQItem[]
    }
}

interface FAQItem  {
    question: string
    answer: string
}

const props = defineProps<PagebuilderFaqProps>()
const { $t, $formatTableHtml } = useNuxtApp()
const initialCount = 5
const collapsable = ref<boolean>(true)
const showAll = ref<boolean>(initialCount >= props.data.faq.length)

const formattedData = computed<FAQItem[]>((): FAQItem[] => {
    if (!collapsable.value) return props.data.faq

    return showAll.value
        ? props.data.faq
        : props.data.faq.slice(0, initialCount)
})
</script>

<template>
  <div
    class="row justify-content-center"
  >
    <div
      v-if="props.data.faq.length"
      class="col-12 col-lg-8 mb-12 mb-lg-0"
    >
      <Accordion>
        <AccordionItem
          v-for="(item, index) in formattedData"
          :key="`faqi-${index}`"
          :btn-index="index"
          :btn-text="item.question"
        >
          <Typo class="mx-4 mx-md-6 mb-4 mb-md-6">
            <div v-html="$formatTableHtml(item.answer)" />
          </Typo>
        </AccordionItem>
      </Accordion>
      <div
        class="d-flex justify-content-center justify-content-md-start m-4"
      >
        <VButton
          v-if="
            (collapsable && !showAll) ||
              !collapsable
          "
          :to="collapsable ? null : { name: 'faq' }"
          color="link"
          type="button"
          class="d-flex align-items-center text-secondary"
          :aria-expanded="showAll.toString()"
          aria-controls="faq-content"
          @click="showAll = true"
        >
          {{ $t('Zobraziť ďalšie otázky a odpovede') }}
          <svg
            class="d-block ms-1 text-secondary"
            aria-hidden="true"
            width="8"
            height="8"
          >
            <use
              :xlink:href="`#${
                collapsable
                  ? 'angle-down'
                  : 'angle-right'
              }`"
            />
          </svg>
        </VButton>
      </div>
    </div>
  </div>
</template>

